import React, { Component } from "react";

import { Wrapper, Copy } from "app/NativeComponents/common";

import OnboardingText from "./OnboardingText";
import BadCardText from "./BadCardText";
import CanceledText from "./CanceledText";
import PausedText from "./PausedText";
import FreeTrialText from "./FreeTrialText";
import NoAccessText from "./NoAccessText";
import IOSText from "./IOSText";
import TrainingText from "./TrainingText";
class GenerateText extends Component {
  render() {
    const { onboarding_info } = this.props;

    return (
      <Wrapper>
        <IOSText {...this.props} onboarding_info={onboarding_info} />
        <OnboardingText {...this.props} />
        <BadCardText {...this.props} onboarding_info={onboarding_info} />
        <CanceledText {...this.props} onboarding_info={onboarding_info} />
        <PausedText {...this.props} onboarding_info={onboarding_info} />

        <FreeTrialText {...this.props} onboarding_info={onboarding_info} />
        <TrainingText {...this.props} onboarding_info={onboarding_info} />

        <NoAccessText {...this.props} onboarding_info={onboarding_info} />
      </Wrapper>
    );
  }
}
export default GenerateText;
